
import {
  defineComponent, computed, ref, watch,
} from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';
import Panel from 'primevue/panel';
import BaseTextInput from '@/components/fields/BaseTextInput.vue';
import BaseTextarea from '@/components/fields/BaseTextarea.vue';
import Tooltip from 'primevue/tooltip';
import FieldErrors from '@/components/fields/partials/FieldErrors.vue';

export default defineComponent({
  name: 'SchemaSettingsPanel',
  components: {
    Panel,
    BaseTextInput,
    BaseTextarea,
    FieldErrors,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    settingPanelValidationErrors: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },

  setup(props: {settingPanelValidationErrors: any }) {
    const { t } = useI18n();
    const store = useStore();
    // get settings from store
    const settings = computed(() => store.getters['customObject/getSettings']);
    const isEditMode = computed(() => store.getters['customObject/isEditMode']);

    const formValidationErrors = ref({});
    const componentFieldErrorsKey = ref(0);
    watch(() => props.settingPanelValidationErrors, () => {
      formValidationErrors.value = props.settingPanelValidationErrors;
      console.log('formValidationErrors', formValidationErrors.value);
      componentFieldErrorsKey.value += 1;
    });

    // update settings in store
    const updateSettings = (payload: Partial<{ name: string; description: string }>) => {
      store.commit('customObject/updateSettings', payload);
    };

    const updateName = (value: string) => {
      updateSettings({ name: value });
    };

    const updateDescription = (value: string) => {
      updateSettings({ description: value });
    };

    return {
      t,
      settings,
      isEditMode,
      updateName,
      updateDescription,
      formValidationErrors,
      componentFieldErrorsKey,
    };
  },
});
